import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const AddressFields = ({ value, onChange, t, prefix = "register" }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div className="space-y-3" data-testid={`${prefix}-address-fields`}>
      <div>
        <Label>{t("street_house")}</Label>
        <Input required value={value.street} onChange={set("street")} placeholder="Seestraße 12" data-testid={`${prefix}-street-input`} />
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div>
          <Label>{t("postal_code")}</Label>
          <Input
            required
            inputMode="numeric"
            pattern="\d{4,5}"
            maxLength={5}
            value={value.postal_code}
            onChange={set("postal_code")}
            data-testid={`${prefix}-plz-input`}
          />
        </div>
        <div className="col-span-2">
          <Label>{t("city")}</Label>
          <Input required value={value.city} onChange={set("city")} data-testid={`${prefix}-city-input`} />
        </div>
      </div>
      <p className="text-xs text-muted-foreground">{t("address_assign_hint")}</p>
    </div>
  );
};
